import React, { useContext, useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

import PageName from "../Utils/PageName";
import { environmentVariables } from "../../config/env.config";
import axios from "axios";
import { userContext } from "../../context/userContext";
import {  toast } from "react-toastify";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import { useTranslation } from "react-i18next";


function CreatePayLink() {
  const { t } = useTranslation();
  const baseUrl = environmentVariables?.apiUrl;
  const { userData, setUserData } = useContext(userContext);

  const [isSubmit, setIsSubmit] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");

  const initialValues = {
    email: "",
    amount: "",
    currency: "",
  };

  let formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t("Invalid_email_address"))
        .required(t("Email_required")),

      currency: Yup.string().required(t("Please_select_country")),

      amount: Yup.string().required(t("Amount_is_required")),
    }),
    onSubmit: async (values) => {
      setIsSubmit(true);

      let data = JSON.stringify({
        email: values?.email,
        amount: values?.amount,
        currency: values?.currency,
      });
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${baseUrl}api/v1/payment/createDynamicPaymentLink`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          setIsSubmit(false);
          toast.success(response?.data?.message);

          console.log("response===>>>", response.data);
          if (!!response.data) {
            setPaymentLink(response.data.paylink);
          }
        })
        .catch((error) => {
          setIsSubmit(false);
          toast.error(error?.response?.data?.message || error?.message);

          console.log(error);
        });
    },
  });

  const { values, errors, handleSubmit } = formik;

  const handleAmountChange = (event) => {
    const { value } = event.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    formik.setFieldValue("amount", numericValue);
  };

  const handleClickCopy = (data) => {
    const resumePreviewLink = data;

    switch ("copy_to_clipboard") {
      case "copy_to_clipboard":
        navigator.clipboard
          .writeText(resumePreviewLink)
          .then(() => {
            console.log("Link copied to clipboard!", resumePreviewLink);

            setTimeout(() => {
              toast.success("Copied");
            }, 2000);
          })
          .catch((err) => {
            console.error("Failed to copy: ", err);
          });
        break;
      default:
        break;
    }
  };
  return (
    <>
      <PageName PageName="Manage banner" />
      <h1 style={{ marginBottom: "50px" }}>Create Payment Link</h1>
      <article>
        <form onSubmit={(e) => handleSubmit(e)} encType="multipart/form-data">
          <div className="modal-body" style={{ padding: "0" }}>
            <div className="mb-2" id="Coupons_admin_createform_container">
              <div className="row">
                <div className="col-lg-4">
                <input
                  placeholder="Email"
                  type="email"
                  className="form-control"
                  value={formik.values.email}
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={{ color: "red" }}>{formik.errors.email}</div>
                ) : null}
                </div>
                <div className="col-lg-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Amount"
                  onChange={handleAmountChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.amount}
                  name="amount"
                  onWheel={(e) => e.target.blur()}
                />
                {formik.touched.amount && formik.errors.amount ? (
                  <div style={{ color: "red" }}>{formik.errors.amount}</div>
                ) : null}
                </div>
                <div className="col-lg-4">
                  <select
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.currency}
                    name="currency"
                  >
                    <option value="">Select Currency*</option>
                    <option value="AED">AED</option>
                    <option value="USD">USD</option>
                  </select>
                  {formik.touched.currency && formik.errors.currency ? (
                    <div style={{ color: "red" }}>{formik.errors.currency}</div>
                  ) : null}
                </div>
              </div>
            </div>

            {/* Activate */}
          </div>

          {/* Submit button */}
          <div className="modal-footer" id="Coupanadmin_Button_Wrapper">
            <button
              id="Coupan_edit_Button"
              type="submit"
              className="btn btn-primary"
              onClick={(e) => handleSubmit(e)}
            >
              {isSubmit ? <CircularLoader /> : "Submit"}
            </button>
          </div>
        </form>
        {paymentLink ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="createpaylinkcon">
              <p>{paymentLink}</p>
              <p
                onClick={() => handleClickCopy(paymentLink)}
                style={{ cursor: "pointer" }}
              >
                copy payment link <i class="fa-solid fa-copy"></i>
              </p>
            </div>
            <p>Payment link will expire in 5 hours.</p>
          </div>
        ) : (
          ""
        )}
      </article>
    </>
  );
}

export default CreatePayLink;
